<template>
  <app-modal
    :modal-id="modalId"
    :preloader="preloader"
    @submit="submit"
    @close-modal="closeModal"
    modal-size="large"
    modal-alignment="top"
  >
    <template slot="header">
      <h5 class="modal-title">Ajuste Plan de Mantenimiento</h5>
      <button
        type="button"
        class="close outline-none"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button>
    </template>
    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        :class="{ 'loading-opacity': preloader }"
        ref="form"
        :data-url="`/accreditationtechnical/setting-information/maintenance/store`"
      >
        <div class="row">
          <div class="col-sm">
            <div class="form-group">
              <label class="mb-0">
                <p class="text-primary">No. Vigilancia</p></label
              >
            </div>
          </div>

          <div class="col-sm">
            <div class="form-group">
              <label class="mb-0"> <p class="text-primary">Fecha</p></label>
            </div>
          </div>
        </div>

        <div class="row" v-for="(value, key) in parents" :key="key">
          <div class="col-sm">
            <div class="form-group">
              {{
                value.name
              }}
            </div>
          </div>

          <div class="col-sm">
            <div class="form-group">
              <app-input
                type="date"
                v-model="value.maintenance_date"
                placeholder="Ingrese Fecha"
              />
            </div>
          </div>
        </div>
      </form>
    </template>

    <template slot="footer">
      <button
        type="button"
        class="btn btn-secondary mr-2"
        data-dismiss="modal"
        @click="closeModal"
      >
        Cerrar
      </button>
      <button type="button" class="btn btn-primary" @click="submit">
        Guardar
      </button>
    </template>
  </app-modal>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { ModalMixin } from "@/app/Mixins/ModalMixin";
import { axiosGet } from "@/app/helpers/AxiosHelper";

export default {
  name: "SettingInfoModal",
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
    accAppId: Number,
  },
  data() {
    return {
      preloader: false,
      modalId: "setting-info-modal",
      inputs: {},
      parents: {},
    };
  },
  created() {
    this.dataParent();
    
  },
  methods: {
    dataParent() {
      this.preloader = true;
      let url = `/accreditationtechnical/setting-information/maintenance/showParent/${this.accAppId}`;
      axiosGet(url)
        .then((response) => {
          if (response.status === 200) {
            // Convertimos cada item en un objeto nuevo correctamente formateado
            this.parents = response.data.map(item => ({
              acc_app_id: item.id,
              acc_parent_id: item.acc_parent_id,
              maintenance_date: item.maintenance_date 
                ? new Date(moment(item.maintenance_date).format("YYYY-MM-DD HH:mm") )
                : "", // Asegura que el campo no sea `null`
              name: item.accreditation_type ? item.accreditation_type.name : ""
            }));
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },
    submit() {   
      this.save(this.parents);
    },
    afterSuccess(response) {
      this.$toastr.s(this.$t("updated_success"));
      this.$hub.$emit("reload-" + this.tableId);
    },
  },
};
</script>

<style>
</style>
